import { IIcon } from '../../model';

export const star: IIcon = {
  id: 'STAR',
  svg: '<path fill="#FFDC46" d="M21.94 8.31c-.14-.46-.54-.8-1-.84l-6.35-.6L12.08.74C11.89.3 11.47 0 11 0c-.47 0-.9.3-1.08.74l-2.5 6.13-6.36.6c-.46.05-.86.38-1 .84-.15.47-.01.98.34 1.3l4.8 4.4-1.42 6.5c-.1.48.08.97.46 1.26a1.13 1.13 0 001.28.06L11 18.4l5.48 3.42c.4.25.9.22 1.28-.06.38-.29.56-.78.46-1.26L16.8 14l4.8-4.4c.35-.32.49-.83.34-1.3z"/>',
};
